module.exports = __webpack_public_path__ + "img/horizontal_3_6_pp1_7042.c3b29afd.png";